// tslint:disable:jsx-no-lambda
// tslint:disable:jsx-no-multiline-js
import * as React from 'react';

import { Button, Modal } from '@abb/common-ux';
import { ISite } from '@module/shared';

interface ISubmitRequestModalProps {
  isOpen: boolean;
  site: ISite;
  onClose: () => void;
  onConfirmClick: () => Promise<boolean>;
}

interface ISubmitRequestModalState {
  waiting: boolean;
}

export class SubmitRequestModal extends React.Component<ISubmitRequestModalProps, ISubmitRequestModalState> {
  constructor(props: ISubmitRequestModalProps) {
    super(props);

    this.state = {
      waiting: false
    };
  }

  render() {
    return (
      <Modal header='Submit to mySpareParts Manager' isOpen={this.props.isOpen} onClose={this.props.onClose} modalClassName='submitRequestModal'>
        <div className='row'>
          <div className='col-sm-12'>
            {`Are you sure you want to submit the request to mySpareParts Manager for site ${this.props.site.servIsId} - ${this.props.site.siteName}?`}
          </div>
        </div>
        <br/>
        {!this.state.waiting && <br/>}
        <div className='row'>
        {this.state.waiting ?
          <div className='col-sm-12' style={{ textAlign: 'center' }}>
            <div className='Spinner_root Spinner_blue Spinner_small'>
              <svg
                viewBox='0 0 100 100'>
                <circle cx='50' cy='50' r='45' />
              </svg>
            </div>
            </div> :
            <React.Fragment>
            <div className='col-sm-offset-6 col-sm-3'>
              <Button
                buttonType='normal'
                buttonSize='small'
                style={{ width: '100%' }}
                onClick={this.props.onClose}
              >Cancel</Button>
            </div>
            <div className='col-sm-3'>
              <Button
                buttonType='primary'
                buttonSize='small'
                style={{ width: '100%' }}
                onClick={this.onConfirmClick}
              >Confirm</Button>
            </div>
            </React.Fragment>
          }
        </div>
      </Modal>
    );
  }

  onConfirmClick = async () => {
    this.setState({ waiting: true });
    if (await this.props.onConfirmClick()) {
      this.props.onClose();
    }
    this.setState({ waiting: false });
  }
}
